if (!customElements.get('product-form')) {
  customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super();

          this.form = this.querySelector('form');
          this.variantIdInput.disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.submitButton = this.querySelector('[type="submit"]');
          this.submitButtonText = this.submitButton.querySelector('span');

          if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

          this.hideErrors = this.dataset.hideErrors === 'true';
        }

        onSubmitHandler(evt) {
          evt.preventDefault();
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

          this.handleErrorMessage();

          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
                'sections',
                this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
          const subsWrapper = document.querySelector('custom-subscription-wrapper');
          let selectedQty = null;
          let sellingPlanValue = null;
          let discountValue = null;


          if (subsWrapper) {
            const checkedRadio = subsWrapper.querySelector('.custom-subscription-radio:checked');

            if (checkedRadio) {
              sellingPlanValue = checkedRadio.value ?? '';
              const item = checkedRadio.closest('.subscription-selling-plan-item') ||
                          subsWrapper.querySelector('.subscription-selling-plan-item.selected-subscription');

              if (item && item.dataset.quantityAdd) {
                selectedQty = parseInt(item.dataset.quantityAdd, 10);
              }

              const discountInput = item?.querySelector('.custom-subscription-discount-value');
              if (discountInput) {
                discountValue = discountInput.value;
              }
              if (item.classList.contains('subscription-one-time-purchase')) {
                const selectedQtyElm = item.querySelector('.quantity__input');
                if (selectedQtyElm) {
                  selectedQty = parseInt(selectedQtyElm.value, 10);
                }

              }
            } else {
              const sel = subsWrapper.querySelector('.subscription-selling-plan-item.selected-subscription');
              if (sel && sel.dataset.quantityAdd) selectedQty = parseInt(sel.dataset.quantityAdd, 10);
              const radio = sel ? sel.querySelector('.custom-subscription-radio') : null;
              sellingPlanValue = radio ? (radio.value ?? '') : '';

              const discountInput = sel?.querySelector('.custom-subscription-discount-value');
              if (discountInput) {
                discountValue = discountInput.value;
              }
            }
          }

          if (selectedQty !== null) {
            formData.set('quantity', String(selectedQty));

            const qtyInputInForm = this.form.querySelector('[name="quantity"]') || document.querySelector(`#Quantity-${this.closest("section").id}`);
            if (qtyInputInForm) qtyInputInForm.value = selectedQty;
          }

          if (sellingPlanValue !== null) {
            formData.set('selling_plan', sellingPlanValue);
          }

          if (discountValue !== null) {
            formData.append('properties[_discount_plan]', discountValue);
          }
          formData.set('properties[_bespokeid]', 'hWN48B1i02xnfhhNVgxd9Y70?key=a8d46631d77ab200b94be6e19d14e70e');

          console.log('Form data to be sent:', Object.fromEntries(formData.entries()));

          fetch(`${routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                if (response.status) {
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    errors: response.errors || response.description,
                    message: response.message,
                  });
                  this.handleErrorMessage(response.description);

                  const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                  if (!soldOutMessage) return;
                  this.submitButton.setAttribute('aria-disabled', true);
                  this.submitButtonText.classList.add('hidden');
                  soldOutMessage.classList.remove('hidden');
                  this.error = true;
                  return;
                } else if (!this.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }

                if (!this.error)
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    cartData: response,
                  });
                this.error = false;
                const quickAddModal = this.closest('quick-add-modal');
                if (quickAddModal) {
                  document.body.addEventListener(
                      'modalClosed',
                      () => {
                        setTimeout(() => {
                          this.cart.renderContents(response);
                        });
                      },
                      { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  this.cart.renderContents(response);
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                this.submitButton.classList.remove('loading');
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                this.querySelector('.loading__spinner').classList.add('hidden');
              });
        }

        handleErrorMessage(errorMessage = false) {
          if (this.hideErrors) return;

          this.errorMessageWrapper =
              this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
          if (!this.errorMessageWrapper) return;
          this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }

        toggleSubmitButton(disable = true, text) {
          if (disable) {
            this.submitButton.setAttribute('disabled', 'disabled');
            if (text) this.submitButtonText.textContent = text;
          } else {
            this.submitButton.removeAttribute('disabled');
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }

        get variantIdInput() {
          return this.form.querySelector('[name=id]');
        }
      }
  );
}
